import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stopPolling } from '../redux/slices/aiReportsSlice';

// Custom hook for managing report polling lifecycle
export const useReportPolling = () => {
  const dispatch = useDispatch();
  const { reportId, isPolling, reportStatus } = useSelector((state) => state.aiReports);
  const pollingRef = useRef(null);

  useEffect(() => {
    // Cleanup on unmount or when polling stops
    return () => {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        dispatch(stopPolling());
      }
    };
  }, [dispatch]);

  // Monitor status changes
  useEffect(() => {
    if (reportStatus === 'completed' || reportStatus === 'failed') {
      if (pollingRef.current) {
        clearInterval(pollingRef.current);
        pollingRef.current = null;
      }
    }
  }, [reportStatus]);

  return { reportId, isPolling, reportStatus };
};
